module.exports = __webpack_public_path__ + "static/media/chat.3b516b61.png";